import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { get, filter, isNil, forEach } from 'lodash';

import {
  REMOVED,
  IComponentStateHistory,
  IValueChangedEvent,
  BaseSetupTab
} from '@nrwl/test-setup';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VoipTestService } from '../../voip-test.service';
import { VoipTestProxyPopupComponent } from '../voip-test-proxy-popup/voip-test-proxy-popup.component';
import {
  DevicesService,
  Device,
  TestMode,
  TestListService,
  UserAuth,
  EntityCacheProvider,
  IApplication,
  DropDownData,
  LogoWidgetService,
  DropDownConfiguration,
  UserService,
  LicensesPageService
} from '@nrwl/common-lib';
import { VoipConfigMapping as ConfigFieldMapping } from '../../json/voip-agent-model';
import { ScheduleLicense } from '@nrwl/licenses';

@Component({
  selector: 'nrwl-voip-test',
  templateUrl: './voip-test.component.html',
  styleUrls: ['./voip-test.component.scss']
})
export class VoipTestComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;
  @Input() stateHistory?: IComponentStateHistory;
  //eslint-disable-next-line
  destinationValue: BehaviorSubject<any>;
  //eslint-disable-next-line
  originatorValue: BehaviorSubject<any>;
  //eslint-disable-next-line
  originatorProxydialogRef: MatDialogRef<any>;
  //eslint-disable-next-line
  destinationProxydialogRef: MatDialogRef<any>;
  @Input() componentId: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreAgentBasedConfig?: Function;
  @Input() tab: BaseSetupTab;
  codecList = [];
  newTestMode = true;
  editMode = false;
  cloneMode = false;
  //eslint-disable-next-line
  originatorDialogRef: MatDialogRef<any>;
  //eslint-disable-next-line
  destinationdialogRef: MatDialogRef<any>;
  selectedOriginator = [];
  selectedDeviceOriginator: Device;
  selectedDeviceDestination: Device;
  selectedDestination = [];
  originatorInfo = {
    title: '',
    label: '',
    subLabel: ''
  };
  destinationInfo = {
    title: '',
    label: '',
    subLabel: '',
    phonenumber: null
  };
  originatorConfiguration = {
    title: 'Originator',
    label: 'Select Originator',
    message: 'Choose a site or agent that will initiate the test',
    icon: 'mdi mdi-star-four-points'
  };
  destinationConfiguration = {
    title: 'Destination',
    label: 'Select Destination',
    message: 'Choose a site or agent that will initiate the test',
    icon: 'mdi mdi-map-marker'
  };
  hasOriginatorProxy = false;
  hasDestinationProxy = false;
  proxyOriginator = 'none';
  dropdownConfiguration: DropDownConfiguration;
  proxyDestination = 'none';
  showSipId = false;
  toggleMessage: string;
  newAppAssigned = false;
  selectedApp: DropDownData;
  imagePath: string;
  startScheduleVal = 'Now';
  repeatScheduleVal = '1min';
  endScheduleVal = 'on-going';
  defaultCodec: string;
  thresholdForCritical: number;
  thresholdForWarning: number;
  nameExist: boolean;
  testName: string;
  testMode: TestMode.DEFAULT;
  allTestNames: Array<string>;
  // editMode: boolean;
  cacheObj: Subscription;
  subContentList = [];
  subContentList1 = [];
  isValidSIPPhoneOrUserId: boolean;
  sipPhoneNumberValue: string;
  hasReadWriteRole = false;
  actualTestName: string;
  showReset = false;
  agentType: string;
  appDropDown = [];
  //eslint-disable-next-line
  originatorProxyConfig: any;
  //eslint-disable-next-line
  destinationProxyConfig: any;
  showDestination = true;
  private readonly _unsubscribe: Subject<void> = new Subject();
  voipScheduleLicense = ScheduleLicense.VOIP;
  isDisabledScheduler = false;
  warningThersholds = {
    max: 5,
    min: 1.1
  };
  criticalThersholds = {
    max: 4.9,
    min: 1
  };
  constructor(
    private readonly licenseService: LicensesPageService,
    private readonly voipTestService: VoipTestService,
    private dialog: MatDialog,
    readonly logoWidgetService: LogoWidgetService,
    readonly entityCache: EntityCacheProvider,
    private userAuth: UserAuth,
    private readonly deviceService: DevicesService,
    private readonly testListService: TestListService,
    private readonly userService: UserService
  ) {
    // eslint-disable-next-line
    this.destinationValue = new BehaviorSubject<any>([]);
    //eslint-disable-next-line
    this.originatorValue = new BehaviorSubject<any>([]);
  }
  ngOnInit(): void {
    this.initializeData();
    this.testMode = TestMode.DEFAULT;
    this.newTestMode = this.voipTestService.mode === 'new';
    this.editMode = this.voipTestService.editMode;
    this.cloneMode = this.voipTestService.mode === 'clone';
    if (!(this.editMode || this.cloneMode)) {
      this.testName = `${this.testName}-${this.userService.getUserName()}-${new Date().getTime()}`;
      this.loadCodecValues();
    }
    this.cacheObj = this.testListService.cache.subscribe(data => {
      this.allTestNames = data.map(item => item.escapedName);
      if (this.testName) {
        this.checkIfNameAlreadyExist();
      }
    });
    this.licenseService.activeTestLicenseDetails.subscribe(licenseData => {
      if (licenseData?.length) {
        this.isDisabledScheduler = !licenseData.some(license =>
          this.voipScheduleLicense?.includes(license.featureName)
        );
      }
      this.isDisabledScheduler
        ? this.onEndScheduleValChange('on-demand')
        : this.onEndScheduleValChange('on-going');
    });
  }

  initializeData(): void {
    this.restoreAgentBasedConfig();
    this.loadCodecValues();
    this.restoreFormValues();
    this.newTestMode = this.voipTestService.mode === 'new';
    this.editMode = this.voipTestService.editMode;
    this.cloneMode = this.voipTestService.mode === 'clone';
  }

  restoreFormValues(): void {
    this.testName = this.restoreFieldValues(ConfigFieldMapping.ALIAS);
    this.actualTestName = this.testName;
    this.endScheduleVal = this.restoreFieldValues(ConfigFieldMapping.RUN_TYPE);
    this.selectedDeviceOriginator = this.restoreFieldValues(ConfigFieldMapping.SELECTED_ORIGINATOR);
    this.selectedDeviceDestination = this.restoreFieldValues(
      ConfigFieldMapping.SELECTED_DESTINATION
    );
    const proxyData = this.restoreFieldValues(ConfigFieldMapping.PROXY_CONFIG);
    const codecValue = proxyData.find(item => item.key === 'voip.codec').value;
    this.defaultCodec = this.codecList.find(item => item.code === codecValue).name;
    this.thresholdForCritical = this.restoreFieldValues(ConfigFieldMapping.THRESHOLD_CRITICALL);
    this.thresholdForWarning = this.restoreFieldValues(ConfigFieldMapping.THRESHOLD_WARNING);
    this.changeCodecValue();
    this.setProxyConfiguration(proxyData);
    this.onChangeThreshold();
  }

  loadCodecValues(): void {
    this.codecList = [
      {
        code: '0',
        name: 'G.711 u-law',
        default: true
      },
      {
        code: '8',
        name: 'G.711 a-law',
        default: false
      },
      {
        code: '18',
        name: 'G.729',
        default: false
      },
      {
        code: '4',
        name: 'G.723.1 6.3kbps',
        default: false
      },
      {
        code: '5',
        name: 'G.723.1 5.3kbps',
        default: false
      }
    ];
    this.defaultCodec = this.codecList.find(item => item?.default).name;
    // if (this.editMode) {
    //   const metaData = get(this.voipTestService.defaultParamsById, 'metaData', []);
    //   const codecValue = metaData.find(item => item.key === 'voip.codec').value;
    //   this.defaultCodec = this.codecList.find(item => item.code === codecValue).name;
    // }
    this.changeCodecValue();
  }
  nameUpdated(): void {
    this.nameExist = false;
    this.onDataEmit(ConfigFieldMapping.ALIAS, null, false);
    if (this.testName) {
      const pattern = new RegExp('[?%/]');
      if (pattern.test(this.testName)) {
        this.form.controls.testName?.setErrors({ regex: 'wrong' });
        this.form.controls.testName?.markAsDirty();
      }
      this.checkIfNameAlreadyExist();
    }
  }

  // eslint-disable-next-line
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }

  changeOriginatorProxy(): void {
    this.originatorProxydialogRef = this.dialog.open(VoipTestProxyPopupComponent, {
      width: '60rem',
      height: 'auto',
      disableClose: true,
      data: {
        data: this.originatorProxyConfig ?? null,
        existPopupData: this.destinationProxyConfig,
        type: 'originator',
        disableNone: this.editMode && this.destinationInfo?.phonenumber
      }
    });
    this.originatorProxydialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.proxyOriginator =
          data.type === 'none' ? data.type : `${data.user} udp://${data.address}:${data.udpPort}`;
        this.onDataEmit('originator_proxy', data, true);
        this.hasOriginatorProxy = data.type === 'custom';
        if (!this.editMode) {
          this.toggleMessage = this.hasOriginatorProxy
            ? !this.showSipId
              ? 'Select by phone number or SIPID'
              : 'Select by site or agent'
            : '';
        }
        this.originatorProxyConfig = data;
        if (data.type === 'none') {
          this.showDestination = true;
          this.proxyDestination = 'none';
          this.destinationProxyConfig = null;
          this.hasDestinationProxy = false;
          this.showSipId = this.editMode && this.destinationInfo['phonenumber'] ? true : false;
          this.onDataEmit('destination_proxy', data, true);
        }
        this.checkHasDestinationProxy();
      }
    });
  }
  changeDestinationProxy(): void {
    this.destinationProxydialogRef = this.dialog.open(VoipTestProxyPopupComponent, {
      width: '60rem',
      height: 'auto',
      data: {
        data: this.destinationProxyConfig ?? null,
        existPopupData: this.originatorProxyConfig,
        type: 'destination',
        disableNone: true
      }
    });
    this.destinationProxydialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.proxyDestination =
          data.type === 'none' ? data.type : `${data.user} udp://${data.address}:${data.udpPort}`;
        this.onDataEmit('destination_proxy', data, true);
        this.destinationProxyConfig = data;
        this.hasDestinationProxy = data.type === 'custom';

        this.checkHasDestinationProxy();
      }
    });
  }
  onEndScheduleValChange(endVal: string): void {
    this.endScheduleVal = endVal;
    this.onDataEmit(ConfigFieldMapping.RUN_TYPE, this.endScheduleVal, true);
  }
  selectSipId(): void {
    this.showSipId = !this.showSipId;
    this.showDestination = !this.showSipId;
    this.toggleMessage = !this.showSipId
      ? 'Select by phone number or SIPID'
      : 'Select by site or agent';
    this.selectedDeviceDestination = null;
    this.sipPhoneNumberValue = '';
    this.proxyDestination = 'none';
    this.hasDestinationProxy = false;
    this.destinationProxyConfig = null;
    this.onDataEmit(ConfigFieldMapping.SELECTED_DESTINATION, null, false);
    this.onDataEmit('destinationproxy', { type: 'none' }, true);
  }

  changeCodecValue(): void {
    const codecCode = this.codecList.find(item => item.name.includes(this.defaultCodec));
    this.onDataEmit('codec', codecCode.code, true);
  }

  onChangeThreshold(): void {
    const isVaild = this.thresholdForWarning > this.thresholdForCritical;
    if (isVaild) {
      this.warningThersholds.min = this.thresholdForCritical + 0.1;
      this.criticalThersholds.max = this.thresholdForWarning - 0.1;
    }
    this.onDataEmit('thresholdWarning', this.thresholdForWarning, isVaild);
    this.onDataEmit('thresholdCritical', this.thresholdForCritical, isVaild);
  }

  checkHasDestinationProxy(): void {
    this.onDataEmit('destinationproxy', true, true);
    if (this.hasOriginatorProxy && !this.showSipId) {
      this.onDataEmit('destinationproxy', true, this.hasDestinationProxy);
    }
  }
  checkIfNameAlreadyExist(): void {
    if (this.editMode) {
      this.allTestNames = this.allTestNames.filter(name => {
        name !== this.testName;
      });
    }
    if (this.allTestNames.some(item => item.toLowerCase() === this.testName.toLowerCase())) {
      this.onDataEmit(ConfigFieldMapping.ALIAS, null, false);
      this.nameExist = true;
    } else {
      this.nameExist = false;
      this.onDataEmit(ConfigFieldMapping.ALIAS, this.testName, true);
    }
  }
  sipPhoneNumberCheck(): void {
    this.isValidSIPPhoneOrUserId = this.voipTestService.isValidSipPhoneNumber(
      this.sipPhoneNumberValue
    );
    const sipInfo = {
      phonenumber: this.sipPhoneNumberValue
    };
    this.onDataEmit(ConfigFieldMapping.SELECTED_DESTINATION, sipInfo, this.isValidSIPPhoneOrUserId);
    if (this.editMode) {
      const output = {};
      output['agent'] = this.destinationInfo['data'].agentSelector;
      output['name'] = this.destinationInfo['data'].label;
      output['phonenumber'] = this.sipPhoneNumberValue;
      this.onDataEmit(
        ConfigFieldMapping.SELECTED_DESTINATION,
        output,
        this.isValidSIPPhoneOrUserId
      );
    }
  }

  setOrgDestData(): void {
    this.originatorValue.next(this.selectedOriginator);
    this.destinationValue.next(this.selectedDestination);
  }

  //eslint-disable-next-line
  setProxyConfiguration(metaData: any): any {
    const no_proxy = 'No Proxy Selected';
    const ori_proxy = JSON.parse(metaData.find(item => item.key === 'sip-proxy-originator').value);
    const dst_proxy = JSON.parse(metaData.find(item => item.key === 'sip-proxy-destination').value);
    if (ori_proxy && ori_proxy['sip-proxy'] && ori_proxy['sip-proxy'] !== no_proxy) {
      const sip_proxy = ori_proxy['sip-proxy'];
      this.proxyOriginator =
        sip_proxy.alias +
        ' ' +
        sip_proxy['proxy-server-config'].transport +
        '://' +
        sip_proxy['proxy-server-config'].address +
        ':' +
        sip_proxy['proxy-server-config'].port;
      const data = {
        user: sip_proxy.alias,
        sign_in: sip_proxy.authentication.name,
        password: sip_proxy.authentication.password,
        address: sip_proxy['proxy-server-config'].address,
        udpPort: sip_proxy['proxy-server-config'].port,
        type: 'custom'
      };
      this.onDataEmit('originator_proxy', data, true);
      this.originatorProxyConfig = data;
      this.hasOriginatorProxy = true;
    }
    if (dst_proxy && dst_proxy['sip-proxy'] && dst_proxy['sip-proxy'] !== no_proxy) {
      const sip_proxy = dst_proxy['sip-proxy'];
      this.proxyDestination =
        sip_proxy.alias +
        ' ' +
        sip_proxy['proxy-server-config'].transport +
        '://' +
        sip_proxy['proxy-server-config'].address +
        ':' +
        sip_proxy['proxy-server-config'].port;
      const data = {
        user: sip_proxy.alias,
        sign_in: sip_proxy.authentication.name,
        password: sip_proxy.authentication.password,
        address: sip_proxy['proxy-server-config'].address,
        udpPort: sip_proxy['proxy-server-config'].port,
        type: 'custom'
      };
      this.destinationProxyConfig = data;
      this.showSipId = false;
      this.hasDestinationProxy = true;
      this.onDataEmit('destination_proxy', data, true);
    }
  }

  //eslint-disable-next-line
  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onAgentChange(data: any): void {
    this.selectedDeviceOriginator = this.deviceService.findDeviceByID(data.originatorId);
    this.selectedDeviceDestination = this.deviceService.findDeviceByID(data.destinationId);
    if (this.selectedDeviceOriginator) {
      this.onDataEmit(ConfigFieldMapping.SELECTED_ORIGINATOR, this.selectedDeviceOriginator, true);
      this.checkHasDestinationProxy();
    }
    if (this.selectedDeviceDestination) {
      this.onDataEmit(
        ConfigFieldMapping.SELECTED_DESTINATION,
        this.selectedDeviceDestination,
        true
      );
      this.checkHasDestinationProxy();
    }
  }

  ngOnDestroy(): void {
    this.cacheObj.unsubscribe();
    this._unsubscribe.complete();
  }
}
